import { useContext } from "react";
import { APIErrorContext } from "./ErrorProvider";

function useAPIError() {
	const {
		error,
		addError,
		removeError,
		showLoader,
		setLoader,
		isViewDetailsOpen,
		setViewDetailsOpen,
	} = useContext(APIErrorContext);
	return {
		error,
		addError,
		removeError,
		showLoader,
		setLoader,
		isViewDetailsOpen,
		setViewDetailsOpen,
	};
}

export default useAPIError;
